import React from 'react';

const formatValue = (value) => (value ? value : '—');

export default function SecFilingTypePill({ filingType }) {
  return formatValue(filingType);
}
